import axios from "axios";

export function uploadVideo(data, onUploadProgress){
    const bannerToken =localStorage.getItem("rfis");

    return axios.post(process.env.REACT_APP_BASE_URL + `api/v1/videos`, data, {
        headers: {
            'rf_token_header123_k': bannerToken,
        },
        onUploadProgress,
    });
}

export function uploadExcel(data){
  const bannerToken =localStorage.getItem("rfis");
  const jsonData = JSON.stringify(data);
  return axios.post(process.env.REACT_APP_BASE_URL + `api/v1/videos/bulk`, jsonData, {
      headers: {
          'rf_token_header123_k': bannerToken,
          'Content-Type': 'application/json'
      
      }
  });
}
// export function getVideos(){
//     const bannerToken =localStorage.getItem("rfis");
//     return axios.get(process.env.REACT_APP_BASE_URL + `api/v1/videos/all`, {
//         headers: {
//             'rf_token_header123_k': bannerToken,
//             'Content-Type': 'application/json'
//         }

//     });
// }
export function deleteVideo(id) {
const token =localStorage.getItem("rfis");
    return axios.delete(
      process.env.REACT_APP_BASE_URL + `api/v1/videos/${id}`,
      {
        headers: {
          rf_token_header123_k: token,
          "Content-Type": "application/json",
        },
      }
    ); 
  }
  

  export async function getVideos(subCategory, language, category, options = {}) {
    const bannerToken = localStorage.getItem("rfis");
    const { categoryId, subCategoryId, limit = 500 } = options;
    const params = new URLSearchParams();

    if (categoryId) {
      params.set("categoryId", String(categoryId));
    } else if (category) {
      params.set("category", category);
    }

    if (subCategoryId) {
      params.set("subCategoryId", String(subCategoryId));
    } else if (subCategory) {
      params.set("subCategory", subCategory);
    }

    if (language) {
      params.set("language", language);
      params.set("language_id", language);
    }

    params.set("limit", String(limit));

    const url = `${process.env.REACT_APP_BASE_URL}api/v1/videos/?${params.toString()}`;
    return axios.get(url, {
      headers: {
        rf_token_header123_k: bannerToken,
        "Content-Type": "application/json",
      },
    });
  }
 

  export function getSingleVideo(id) {
    let url = process.env.REACT_APP_BASE_URL + `api/v1/videos/single/${id}`;
    const bannerToken =localStorage.getItem("rfis");
    return axios.get(url, {
      headers: {
        rf_token_header123_k: bannerToken,
        "Content-Type": "application/json",
      },
    });
  }

  export function updateVideo(id, data, onUploadProgress){
    const bannerToken =localStorage.getItem("rfis");
    return axios.put(process.env.REACT_APP_BASE_URL + `api/v1/videos/${id}`, data, {
        headers: {
            'rf_token_header123_k': bannerToken,
        },
        onUploadProgress,
    });
}
